import { Controller, set, useForm } from 'react-hook-form';
import { getHCCSpecialityMasterCodes } from '../../services/hccService';
import Select from 'react-select';
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import { hashField } from '../../utils/cryptoUtils';
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import './React-date.css';

function Filter({ hccDropdownOptions, setFilters, setCurrentPage }) {
    const [isLoading, setIsLoading] = useState(false);
    const [masterCode, setMasterCode] = useState(null);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showDate, setShowDate] = useState('');
    const [showReceiveDate, setShowReceiveDate] = useState('');
    const [receiveDate, setReceiveDate] = useState('');
    const [date, setDate] = useState('');
    const [showReviewDate, setShowReviewDate] = useState('');
    const [reviewDate, setReviewDate] = useState('');
    const originalCodeRef = useRef(null);
    const revisedCodeRef = useRef(null);
    const {
        register,
        handleSubmit,
        control,
        reset,
        watch,
        setError,
        clearErrors,
        formState: { errors }
    } = useForm();

    const from = watch("dateOfBirthFrom");
    const to = watch("dateOfBirthTo");

    const onSubmit = async (data) => {
        if ((from && !to) || (!from && to)) {
            if (!from) {
                setError("dateOfBirthFrom", { type: "manual", message: "Required" });
            }
            if (!to) {
                setError("dateOfBirthTo", { type: "manual", message: "Required" });
            }
            return;
        }

        if (from && to && to.isBefore(from)) {
            setError("dateOfBirthTo", {
                type: "manual",
                message: "To date must be after or same as From date",
            });
            return;
        }
        const reqBody = {};
        if (data.coder?.value) {
            reqBody.coder = data.coder.value;
        }
        if (data.v24) {
            reqBody.v24 = data.v24;
        }
        if (data.v28) {
            reqBody.v28 = data.v28;
        }
        if (data.validate?.value) {
            reqBody.ValidateId = data.validate.value;
        }
        if (data.source?.value) {
            reqBody.SourceId = data.source.value;
        }
        if (data.reasonCode?.value) {
            reqBody.ReasonCodeId = data.reasonCode.value;
        }
        if (data.originalCode?.[0]?.name) {
            reqBody.originalCode = data.originalCode?.[0]?.name;
        }
        if (data.revisedCode?.[0]?.name) {
            reqBody.revisedCode = data.revisedCode?.[0]?.name;
        }
        if (date) {
            reqBody.dateOfService = date;
        }
        if (receiveDate) {
            reqBody.receivedDate = receiveDate;
        }
        if (reviewDate) {
            reqBody.reviewDate = reviewDate;
        }
        if(data?.dateOfBirthFrom && data?.dateOfBirthTo){

            reqBody.dateOfBirth = `${moment(data?.dateOfBirthFrom).format('MM/DD/YYYY')} - ${moment(data?.dateOfBirthTo).format('MM/DD/YYYY')}`;
        }
        if(data.memberId){
            reqBody.memberIdHash = hashField(data.memberId);
        }
        if(data.medicareNo){
            reqBody.medicareNoHash = hashField(data.medicareNo);
        }

        setFilters(reqBody);
        setCurrentPage(1);
        setShowFilterModal(false);
    }

    const onHide = () => {
        setShowFilterModal(false);
        handleReset();
    }

    const fetchHCCSpecialityOriginalCodes = async () => {
        try {
            setIsLoading(true);
            const reqBody = {
                code: originalCodeRef?.current?.state?.text,
                flag: 'filter',
            }
            const res = await getHCCSpecialityMasterCodes({ data: reqBody });
            if (res.success) {
                setMasterCode(res?.data);
            }
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    const fetchHCCSpecialityRevisedCodes = async () => {
        try {
            setIsLoading(true);
            const reqBody = {
                code: revisedCodeRef?.current?.state?.text,
                flag: 'filter',
            }
            const res = await getHCCSpecialityMasterCodes({ data: reqBody });
            if (res.success) {
                setMasterCode(res?.data);
            }
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    const handleReset = () => {
        reset({
            medicareNo: '',
            coder: {},
            v24: "",
            v28: "",
            validate: {},
            source: {},
            reasonCode: {},
            originalCode: [],
            revisedCode: [],
            dateOfBirthFrom: '',
            dateOfBirthTo: '',
        });
        setShowDate('');
        setReceiveDate('');
        setShowReceiveDate('');
        setDate('');
        setFilters({});
        setCurrentPage(1);
        setShowFilterModal(false);
        setShowReviewDate('');
        setReviewDate('');
    };

    const handleDate = (event, picker) => {
        const formattedDate = `${picker.startDate.format('MM/DD/YYYY')} - ${picker.endDate.format('MM/DD/YYYY')}`;
        picker.element.val(formattedDate);
        setShowDate(formattedDate);
        const dates = formattedDate.split(' - ');
        const formattedDates = dates.map((data) => moment(data, 'MM/DD/YYYY').format('MM/DD/YYYY'));
        const formattedDateString = formattedDates.join(' - ');
        setDate(formattedDateString);
    };

    const handleCancelDate = (event, picker) => {
        picker.element.val('');
        setDate('');
        setShowDate('');
    };

    const handleReviewDate = (event, picker) => {
        const formattedDate = `${picker.startDate.format('MM/DD/YYYY')} - ${picker.endDate.format('MM/DD/YYYY')}`;
        picker.element.val(formattedDate);
        setShowReviewDate(formattedDate);
        const dates = formattedDate.split(' - ');
        const formattedDates = dates.map((data) => moment(data, 'MM/DD/YYYY').format('MM/DD/YYYY'));
        const formattedDateString = formattedDates.join(' - ');
        setReviewDate(formattedDateString);
    };

    const handleCancelReviewDate = (event, picker) => {
        picker.element.val('');
        setReviewDate('');
        setShowReviewDate('');
    };

    const handleReceiveDate = (event, picker) => {
        const formattedDate = `${picker.startDate.format('MM/DD/YYYY')} - ${picker.endDate.format('MM/DD/YYYY')}`;
        picker.element.val(formattedDate);
        setShowReceiveDate(formattedDate);
        const dates = formattedDate.split(' - ');
        const formattedDates = dates.map((data) => moment(data, 'MM/DD/YYYY').format('MM/DD/YYYY'));
        const formattedDateString = formattedDates.join(' - ');
        setReceiveDate(formattedDateString);
    };

    const handleCancelReceiveDate = (event, picker) => {
        picker.element.val('');
        setReceiveDate('');
        setShowReceiveDate('');
    };

    const renderCodeOptions = () => masterCode?.map((item) => ({ name: item?.code, id: item?.id }));
    const renderValidateOptions = () => hccDropdownOptions?.validate?.map((item) => ({ value: item?.id, label: item?.name }));
    const rendersourceOptions = () => hccDropdownOptions?.source?.map((item) => ({ value: item?.id, label: item?.name }));
    const renderReasonCodeOptions = () => hccDropdownOptions?.reasonCode?.map((item) => ({ value: item?.id, label: item?.name }));
    const renderCoderOptions = () => hccDropdownOptions?.users?.map((item) => ({ value: item?.id, label: `${item?.first_name} ${item?.last_name}` }));

    return (
        <div>
            <button
                type="button"
                className="btn btn-light-primary ms-4 btn-filter"
                onClick={() => setShowFilterModal(true)}
            >
                <i className="fas fa-filter"></i>
                {" Filter"}
            </button>

            <Modal show={showFilterModal} onHide={onHide} size="lg" centered>
                <div className="pb-4">
                    <Modal.Header className="pb-2" closeButton>
                        <Modal.Title>
                            <h2>Filter Options</h2>
                        </Modal.Title>
                    </Modal.Header>

                    <div className="separator border-gray-200" />

                    <form
                        className="px-7 py-3"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <div className="row">
                            <div className="col-lg-3 col-12  mb-1">
                                <div className="mb-1">
                                    <label className="form-label">Member Id</label>
                                    <input 
                                        type="text"
                                        className="form-control"
                                        {...register('memberId')}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 col-12  mb-1">
                                <div className="mb-1">
                                    <label className="form-label">Medicare No.</label>
                                    <input 
                                        type="text"
                                        className="form-control"
                                        {...register('medicareNo')}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 col-12  mb-1">
                                <div className="mb-1">
                                    <label className="form-label">Date of Birth (From)</label>
                                    <Controller
                                        name="dateOfBirthFrom"
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                            <Datetime
                                                timeFormat={false}
                                                dateFormat="MM/DD/YYYY"
                                                inputProps={{ placeholder: 'Pick a Date', className: 'form-control' }}
                                                value={value || ''}
                                                onChange={(val) => {
                                                    onChange(val);
                                                    clearErrors("dateOfBirthFrom");
                                                }}
                                                closeOnSelect={true}
                                                initialViewDate={moment('01/01/1960', 'MM/DD/YYYY').format('MM/DD/YYYY')}
                                            />
                                        )}
                                    />
                                </div>
                                {errors.dateOfBirthFrom && (
                                    <small className="text-danger">{errors.dateOfBirthFrom.message}</small>
                                )}
                            </div>
                            <div className="col-lg-3 col-12  mb-1">
                                <div className="mb-1">
                                    <label className="form-label">Date of Birth (To)</label>
                                    <Controller
                                        name="dateOfBirthTo"
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                            <Datetime
                                                timeFormat={false}
                                                dateFormat="MM/DD/YYYY"
                                                inputProps={{ placeholder: 'Pick a Date', className: 'form-control' }}
                                                value={value || ''}
                                                onChange={(val) => {
                                                    onChange(val);
                                                    clearErrors("dateOfBirthTo");
                                                }}
                                                closeOnSelect={true}
                                                initialViewDate={moment('01/01/1960', 'MM/DD/YYYY').format('MM/DD/YYYY')}
                                            />
                                        )}
                                    />
                                </div>
                                {errors.dateOfBirthTo && (
                                    <small className="text-danger">{errors.dateOfBirthTo.message}</small>
                                )}
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <div className="mb-1">
                                    <label className="form-label">Date of Service</label>
                                    <DateRangePicker
                                        onApply={handleDate}
                                        onCancel={handleCancelDate}
                                        initialSettings={{
                                            autoUpdateInput: false,
                                            locale: {
                                                cancelLabel: 'Clear',
                                                format: 'MM/DD/YYYY',
                                            },
                                            showDropdowns: true,
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Start Date  -  End Date"
                                            autoComplete="off"
                                            className="form-control"
                                            readOnly
                                            value={showDate ?? ''}
                                        />
                                    </DateRangePicker>
                                </div>
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <div className="mb-1">
                                    <label className="form-label">Received Date</label>
                                    <DateRangePicker
                                        onApply={handleReceiveDate}
                                        onCancel={handleCancelReceiveDate}
                                        initialSettings={{
                                            autoUpdateInput: false,
                                            locale: {
                                                cancelLabel: 'Clear',
                                                format: 'MM/DD/YYYY',
                                            },
                                            showDropdowns: true,
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Start Date  -  End Date"
                                            autoComplete="off"
                                            className="form-control"
                                            readOnly
                                            value={showReceiveDate ?? ''}
                                        />
                                    </DateRangePicker>
                                </div>
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <div className="mb-1">
                                    <label className="form-label">Review Date</label>
                                    <DateRangePicker
                                        onApply={handleReviewDate}
                                        onCancel={handleCancelReviewDate}
                                        initialSettings={{
                                            autoUpdateInput: false,
                                            locale: {
                                                cancelLabel: 'Clear',
                                                format: 'MM/DD/YYYY',
                                            },
                                            showDropdowns: true,
                                        }}
                                    >
                                        <input
                                            type="text"
                                            placeholder="Start Date  -  End Date"
                                            autoComplete="off"
                                            className="form-control"
                                            readOnly
                                            value={showReviewDate ?? ''}
                                        />
                                    </DateRangePicker>
                                </div>
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <div className="mb-1">
                                    <label className="form-label">
                                        Coder{" "}
                                    </label>
                                    <Controller
                                        name="coder"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                components={{ IndicatorSeparator: () => null }}
                                                options={renderCoderOptions()}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <div className="mb-1">
                                    <label className="form-label">V24 ICD Code</label>
                                    <Controller
                                        name="originalCode"
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                            <AsyncTypeahead
                                                filterBy={() => true}
                                                isLoading={isLoading}
                                                selected={value}
                                                id="originalCode"
                                                placeholder="..."
                                                labelKey={option => option?.name}
                                                ignoreDiacritics={true}
                                                options={renderCodeOptions()}
                                                useCache={false}
                                                debounceTime={800}
                                                minLength={2}
                                                onSearch={fetchHCCSpecialityOriginalCodes}
                                                ref={originalCodeRef}
                                                onChange={(val) => {
                                                    onChange(val);
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <div className="mb-1">
                                    <label className="form-label">V28 ICD Code </label>
                                    <Controller
                                        name="revisedCode"
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                            <AsyncTypeahead
                                                filterBy={() => true}
                                                isLoading={isLoading}
                                                id="revisedCode"
                                                placeholder="..."
                                                selected={value}
                                                labelKey={option => option?.name}
                                                ignoreDiacritics={true}
                                                options={renderCodeOptions()}
                                                useCache={false}
                                                debounceTime={800}
                                                minLength={2}
                                                onSearch={fetchHCCSpecialityRevisedCodes}
                                                ref={revisedCodeRef}
                                                onChange={(val) => onChange(val)}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <div className="mb-1">
                                    <label className="form-label">V24 HCC Value</label>
                                    <input className="form-control" type="text" {...register("v24")} />
                                </div>
                            </div>
                            <div className="col-lg-3 col-6 mb-1">
                                <label className="form-label">
                                    Validate
                                </label>
                                <Controller
                                    name="validate"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            components={{ IndicatorSeparator: () => null }}
                                            options={renderValidateOptions()}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <label className="form-label">V28 HCC Value</label>
                                <input className='form-control' type="text" {...register("v28")} />
                            </div>
                            <div className="col-lg-3 col-12 mb-1">
                                <label className="form-label">Reason Code  </label>
                                <Controller
                                    name="reasonCode"
                                    rules={{
                                        // required: { value: true, message: 'Required' },
                                    }}
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            components={{ IndicatorSeparator: () => null }}
                                            options={renderReasonCodeOptions()}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-lg-3 col-6 mb-1">
                                <label className="form-label">Source </label>
                                <Controller
                                    name="source"
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            components={{ IndicatorSeparator: () => null }}
                                            options={rendersourceOptions()}
                                        />
                                    )}
                                />
                            </div>


                        </div>

                        <div className="d-flex justify-content-end mt-8">
                            <button
                                type="reset"
                                className="btn btn-sm btn-light btn-active-light-primary me-2"
                                data-kt-menu-dismiss="true"
                                onClick={handleReset}
                            >
                                Reset
                            </button>
                            <button
                                type="submit"
                                className="btn btn-sm btn-primary"
                                data-kt-menu-dismiss="true"
                            >
                                Apply
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    )
}

export default Filter